import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosnglicab() {



    const cardData = {

keyword: "Pune to Sangli Cab",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and affordable Pune to Sangli Cab services for families, business travelers, students, and tourists. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs for a smooth highway journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are traveling for business, education, or family visits, Rising Cab Service ensures a reliable and hassle-free travel experience to Sangli.",

topPlaces: [
    {
        title: "Ganapati Temple Sangli",
        description:
            "Sangli Ganapati Temple is a famous and ancient temple dedicated to Lord Ganesha, attracting devotees from across Maharashtra for blessings and spiritual peace."
    },
    {
        title: "Sangli Fort",
        description:
            "Sangli Fort is a historic structure reflecting Maratha-era architecture and regional heritage, making it an important cultural landmark in the city."
    },
    {
        title: "Krishna River Ghats",
        description:
            "The Krishna River Ghats in Sangli are peaceful and scenic spots where locals and visitors enjoy morning walks, religious rituals, and relaxing evenings."
    },
    {
        title: "Chandoli National Park",
        description:
            "Chandoli National Park near Sangli is a rich biodiversity zone known for wildlife, dense forests, and eco-tourism activities in the Western Ghats."
    },
    {
        title: "Sagareshwar Wildlife Sanctuary",
        description:
            "Sagareshwar Wildlife Sanctuary is a unique man-made forest area known for deer, birds, and religious temples inside the sanctuary, offering a blend of nature and spirituality."
    },
    {
        title: "Vishrambaug Wada Sangli",
        description:
            "Vishrambaug Wada is a historical mansion showcasing traditional architecture and local heritage of Sangli region."
    },
    {
        title: "Dandoba Hill Station",
        description:
            "Dandoba Hills near Sangli is a small but scenic hill area known for temples, trekking, and panoramic views of the surrounding landscape."
    },
    {
        title: "Industrial Area MIDC",
        description:
            "Sangli MIDC is an important industrial zone known for sugar factories, manufacturing units, and agricultural processing industries."
    },
    {
        title: "Miraj City",
        description:
            "Miraj near Sangli is famous for its musical instrument industry, hospitals, and cultural significance in Western Maharashtra."
    },
    {
        title: "Krishna Valley Sugar Belt",
        description:
            "The Krishna Valley region around Sangli is known for sugarcane farming, sugar factories, and agricultural importance in Maharashtra."
    }
],



services: [
    {
        name: "Pune to Sangli Cab",
        description:
            "Rising Cab Service offers Pune to Sangli Cab for safe, comfortable, and reliable intercity travel across Maharashtra. This service is ideal for family visits, business travel, student trips, and weekend journeys. We provide well-maintained AC vehicles including hatchbacks, sedans, SUVs, Innova, and Innova Crysta with experienced highway drivers ensuring smooth and timely travel. Customers can choose one-way or round-trip options with door-to-door pickup and drop service. With transparent pricing, 24x7 availability, and professional support, we ensure a hassle-free journey between Pune and Sangli."
    },
    {
        name: "Pune to Sangli Taxi",
        description:
            "Book Pune to Sangli Taxi with Rising Cab Service for affordable, safe, and comfortable travel. Our taxis are suitable for solo passengers, families, and corporate travelers looking for dependable intercity transportation with clean vehicles and professional chauffeurs."
    },
    {
        name: "Cab from Pune to Sangli",
        description:
            "Rising Cab Service provides Cab from Pune to Sangli with flexible booking options, door-to-door pickup, and comfortable AC vehicles for smooth highway travel experience."
    },
    {
        name: "Taxi from Pune to Sangli",
        description:
            "Our Taxi from Pune to Sangli service ensures safe and punctual travel with experienced drivers, well-maintained vehicles, and affordable pricing for all types of passengers."
    },
    {
        name: "Pune to Sangli Cab Service",
        description:
            "Rising Cab Service offers Pune to Sangli Cab Service with reliable transportation, easy booking, and professional drivers ensuring a smooth and stress-free journey."
    },
    {
        name: "Pune to Sangli Taxi Fare",
        description:
            "Get transparent Pune to Sangli Taxi Fare with no hidden charges. We offer competitive pricing suitable for one-way and round-trip travel across Maharashtra."
    },
    {
        name: "Pune to Sangli One Way Cab",
        description:
            "Book Pune to Sangli One Way Cab for affordable single-trip travel with comfortable vehicles and professional drivers ensuring safe highway journey."
    },
    {
        name: "Pune to Sangli Round Trip Taxi",
        description:
            "Rising Cab Service provides Pune to Sangli Round Trip Taxi with flexible return timing, waiting options, and customized travel plans for families and business travelers."
    },
    {
        name: "Pune to Sangli Cab Booking",
        description:
            "Our Pune to Sangli Cab Booking service offers instant confirmation, multiple vehicle options, and 24x7 support for easy and fast travel planning."
    },
    {
        name: "Cheap Pune to Sangli Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Sangli Cab with budget-friendly fares while ensuring safety, comfort, and reliable service quality for all passengers."
    },
    {
        name: "Best Pune to Sangli Taxi",
        description:
            "Choose the Best Pune to Sangli Taxi with Rising Cab Service for premium comfort, punctual service, and experienced drivers ensuring smooth highway travel."
    },
    {
        name: "Sedan Pune to Sangli Cab",
        description:
            "Our Sedan Pune to Sangli Cab is ideal for individuals and small families seeking affordable, comfortable, and fuel-efficient intercity travel."
    },
    {
        name: "SUV Pune to Sangli Taxi",
        description:
            "Book SUV Pune to Sangli Taxi for spacious seating, extra luggage capacity, and comfortable group travel on long highway routes."
    },
    {
        name: "Innova Pune to Sangli Cab",
        description:
            "Rising Cab Service offers Innova Pune to Sangli Cab for family and group travel with premium comfort, smooth rides, and reliable long-distance service."
    },
    {
        name: "Highway Cab Pune Sangli",
        description:
            "Our Highway Cab Pune Sangli service ensures fast, safe, and efficient travel using well-planned highway routes with experienced drivers for time-saving journeys."
    },
    {
        name: "Pune to Sangli Cabs",
        description:
            "Rising Cab Service provides Pune to Sangli Cabs with one-way, round-trip, and customized travel solutions for all passenger requirements."
    },
    {
        name: "Pune to Sangli Cab Service",
        description:
            "Our Pune to Sangli Cab Service ensures reliable intercity transportation with clean vehicles, professional chauffeurs, and affordable pricing."
    },
    {
        name: "Pune to Sangli Taxi Service",
        description:
            "Book Pune to Sangli Taxi Service for safe and convenient travel with door-to-door pickup and drop facilities across Maharashtra."
    },
    {
        name: "Best Pune to Sangli Cab",
        description:
            "Choose the Best Pune to Sangli Cab for high-quality service, comfortable rides, and dependable intercity travel experience."
    },
    {
        name: "One Way Pune to Sangli Cab",
        description:
            "Book One Way Pune to Sangli Cab for economical single-direction travel with experienced drivers and clean vehicles."
    },
    {
        name: "Round Trip Pune to Sangli Taxi",
        description:
            "Our Round Trip Pune to Sangli Taxi service provides flexible travel planning with return journey options and customized packages."
    },
    {
        name: "Cheap Pune to Sangli Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Sangli Cab with affordable fares and safe, comfortable travel options."
    },
    {
        name: "24x7 Pune to Sangli Cab Service",
        description:
            "Book 24x7 Pune to Sangli Cab Service with Rising Cab Service for round-the-clock availability and quick response anytime you need travel support."
    },
    {
        name: "Outstation Cab Pune to Sangli",
        description:
            "Our Outstation Cab Pune to Sangli service ensures safe, comfortable, and reliable intercity travel for families, professionals, and tourists."
    },
    {
        name: "Pune to Satara Cab",
        description:
            "Rising Cab Service offers Pune to Satara Cab with smooth highway travel, clean vehicles, and professional drivers for short-distance intercity trips."
    },
    {
        name: "Pune to Satara Cab Service",
        description:
            "Book Pune to Satara Cab Service for reliable, affordable, and comfortable transportation with door-to-door pickup and drop service."
    },
    {
        name: "Pune to Satara Taxi Service",
        description:
            "Our Pune to Satara Taxi Service ensures safe travel with experienced chauffeurs and well-maintained AC vehicles for smooth journeys."
    },
    {
        name: "Pune to Satara Cab Booking",
        description:
            "Rising Cab Service provides Pune to Satara Cab Booking with instant confirmation, flexible scheduling, and 24x7 customer support."
    },
    {
        name: "Best Pune to Satara Cab",
        description:
            "Choose the Best Pune to Satara Cab for reliable service, comfortable travel experience, and professional drivers."
    },
    {
        name: "One Way Pune to Satara Cab",
        description:
            "Book One Way Pune to Satara Cab for budget-friendly single-trip travel with safe and convenient transportation options."
    },
    {
        name: "Round Trip Pune to Satara Taxi",
        description:
            "Our Round Trip Pune to Satara Taxi service provides return journey flexibility and customized travel planning for families and business users."
    },
    {
        name: "Cheap Pune to Satara Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Satara Cab with economical pricing while maintaining safety and comfort standards."
    },
    {
        name: "24x7 Pune to Satara Cab Service",
        description:
            "Book 24x7 Pune to Satara Cab Service with us for round-the-clock availability and reliable intercity travel support anytime."
    }
],
tableData: [
    ["Pune to Sangli Cab", "Pune to Sangli Taxi"],
    ["Cab from Pune to Sangli", "Taxi from Pune to Sangli"],
    ["Pune to Sangli One Way Cab", "Pune to Sangli Round Trip Taxi"],
    ["Pune to Sangli Cab Service", "Pune to Sangli Taxi Fare"],
    ["Cheap Pune to Sangli Cab", "Best Pune to Sangli Taxi"],
    ["Sedan Pune to Sangli Cab", "SUV Pune to Sangli Taxi"],
    ["Innova Pune to Sangli Cab", "Highway Cab Pune Sangli"],
    ["Pune to Sangli Cab Booking", "Outstation Cab Pune to Sangli"],
    ["Pune to Satara Cab", "Pune to Satara Cab Service"],
    ["Pune to Satara Taxi Service", "Pune to Satara Cab Booking"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Sangli Cab Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable and dependable Pune to Sangli cab transportation for families, business travelers, students, tourists, and regular commuters."
    },
    {
        WhyChooseheading: "Ideal for Business and Personal Travel",
        WhyChoosedescription: "Whether you're visiting Sangli for official work, family functions, educational purposes, medical appointments, or personal commitments, we offer suitable travel solutions."
    },
    {
        WhyChooseheading: "Comfortable Fleet for Every Journey",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles to match your travel requirements and budget."
    },
    {
        WhyChooseheading: "Flexible Travel Packages Available",
        WhyChoosedescription: "Customers can select one-way trips, round-trip bookings, same-day return journeys, or customized travel plans according to their schedule."
    },
    {
        WhyChooseheading: "Popular Route for Family Visits and Events",
        WhyChoosedescription: "Many travelers prefer our Pune to Sangli cab service for weddings, social gatherings, festivals, family visits, and special occasions."
    },
    {
        WhyChooseheading: "Pickup Service Across Pune & PCMC",
        WhyChoosedescription: "Convenient pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding areas."
    },
    {
        WhyChooseheading: "Smooth Highway Travel Experience",
        WhyChoosedescription: "Our experienced drivers ensure safe driving and comfortable travel throughout the Pune to Sangli route."
    },
    {
        WhyChooseheading: "Travel Planning Made Easy",
        WhyChoosedescription: "Rising Cab Service helps customers enjoy hassle-free transportation with professional support and convenient booking options."
    }
]
};

const faqData = [
    {
        question: "Why do travelers frequently visit Sangli from Pune?",
        answer: "Sangli is known for its educational institutions, business activities, family connections, cultural events, and proximity to important destinations in Western Maharashtra."
    },
    {
        question: "Can I reserve a one-way cab from Pune to Sangli?",
        answer: "Yes, one-way transportation is available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for long-distance family travel?",
        answer: "Ertiga and Innova Crysta are commonly selected for family journeys because of their spacious interiors and comfort."
    },
    {
        question: "Do you provide same-day return cab services?",
        answer: "Yes, customers can choose same-day return options depending on their travel schedule."
    },
    {
        question: "Can business professionals use this route regularly?",
        answer: "Yes, many professionals book Pune to Sangli cabs for meetings, industrial visits, and corporate travel requirements."
    },
    {
        question: "Are larger vehicles available for group transportation?",
        answer: "Yes, Tempo Travellers and group vehicles can be arranged for family functions, events, and organized travel."
    },
    {
        question: "Can multiple destinations be included during the trip?",
        answer: "Yes, customers can customize their itinerary with additional stops, nearby cities, temples, or tourist attractions."
    },
    {
        question: "Is pickup available from Pune Airport and Railway Station?",
        answer: "Yes, travelers can start their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "When should customers book their cab in advance?",
        answer: "Advance reservations are recommended during weekends, holidays, festive seasons, and wedding periods."
    },
    {
        question: "How can I book a Pune to Sangli Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Amol Patankar",
        feedback:
            "For a recent visit to Sangli, the entire journey was managed exceptionally well. The vehicle was comfortable, and the travel experience remained smooth throughout the route.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Swati Chougule",
        feedback:
            "Our family traveled to Sangli for a special occasion and received excellent service. Everything from pickup timing to overall travel coordination was handled professionally.",
        rating: 5
    }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Sangli Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-sangli-cab.jpg",
"description": "Book Pune to Sangli Cab Service with Rising Cab Service for safe, comfortable, and affordable outstation travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for family and business trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-sangli-cab"
}
};







    return (
        <div>


<Helmet>
  <title>Pune to Sangli Cab Service | One Way & Round Trip Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Sangli Cab Service for safe and affordable outstation travel. Get reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to sangli cab, pune to sangli taxi, cab from pune to sangli, taxi from pune to sangli, pune to sangli cab service, pune to sangli taxi fare, pune to sangli one way cab, pune to sangli round trip taxi, pune to sangli cab booking, cheap pune to sangli cab, best pune to sangli taxi, sedan pune to sangli cab, suv pune to sangli taxi, innova pune to sangli cab, highway cab pune sangli, Pune to Sangli Cab Service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosnglicab;